import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
class TopFixedMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      className: '',
    }
    this.handleScroll = this.handleScroll.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);
  }
  componentWillMount() {
     window.addEventListener('scroll', this.handleScroll);
  }
  componentWillUnmount() {
     window.removeEventListener('scroll', this.handleScroll);
  }
  handleScroll(event) {
    const { fixedMenuTopHeight } = this.props;
    const height = event.srcElement.body.scrollTop;
    if ( height > fixedMenuTopHeight ) {
      this.setState({className: ' fix-top-menu'});
    }
    else {
      this.setState({className: ''});
    }
  }
  toggleMenu() {
    if ( this.state.className.length > 0) {
      this.setState({className: ''});
    }
    else {
      this.setState({className: ' show-mobile-menu'});
    }
  }
  render() {
    return (
      <div>
        <div onClick={this.toggleMenu} className="mobile-menu-icon large-hidden">
          <a>
            <i className="fa fa-bars"></i>
          </a>
        </div>
        <div className={`row main-menu-wrapper ${this.state.className}`}>
          {this.props.children}
        </div>
      </div>
    );
  }
}
export default TopFixedMenu;



// WEBPACK FOOTER //
// ./src/components/TopFixedMenu.js